import { render, staticRenderFns } from "./ContestEntryWorkSelectForm.vue?vue&type=template&id=ed78853c&scoped=true"
import script from "./ContestEntryWorkSelectForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContestEntryWorkSelectForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ContestEntryWorkSelectForm.vue?vue&type=style&index=0&id=ed78853c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed78853c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed78853c')) {
      api.createRecord('ed78853c', component.options)
    } else {
      api.reload('ed78853c', component.options)
    }
    module.hot.accept("./ContestEntryWorkSelectForm.vue?vue&type=template&id=ed78853c&scoped=true", function () {
      api.rerender('ed78853c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/event/ContestEntryWorkSelectForm.vue"
export default component.exports